import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common'
import { ActivatedRoute, Router } from '@angular/router';
import { WallboardService } from 'src/app/services/wallboard/wallboard.service';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-wallboard-life',
  templateUrl: './wallboard-life.component.html',
  styleUrls: ['./wallboard-life.component.css']
})
export class WallboardLifeComponent implements OnInit {

  showWallboard = false;
  time = new Date();
  timer: any;
  queueDisplayIteration = 0;
  wbInterval: any;
  siteMetrics = [];
  activeAnnouncement = '';
  announcementIteration = 0;
  mainTitle = "Main View";
  secondEnabled = true;
  combinedMetrics = {
    title: '',
    metrics: []
  }
  combinedThresholds = {};

  constructor(
    public wallboardService: WallboardService,
    private route: ActivatedRoute,
    private location: Location,
    private configService: ConfigService,
    private router: Router
  ) { }

  ngOnInit() {
    this.showWallboard = false;
    this.wallboardService.getConfigDataLife(this.configService.activeLOBLife).then(() => {
    this.configService.getQueueList();
      if (this.route.snapshot.params.site) {
        for (let i = 0; i < this.wallboardService.configurationsLife.length; i++) {
            let config = this.wallboardService.configurationsLife[i];
            if (config.View === this.route.snapshot.params.site) {
              this.updateActiveSite(this.route.snapshot.params.site);
              return config.View;
            }
        }
      } else {
        if (this.wallboardService.activeSiteNameLife) {
          this.updateActiveSite(this.wallboardService.activeSiteNameLife);
        }
      }
    })

    //this controls the clock in the upper right
    this.timer = setInterval(() => {
      this.time = new Date();
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.wbInterval);
    this.wallboardService.showWallboardLife = false;
    this.wallboardService.activeSiteNameLife = '';
    //this clears the clock's timer
    clearInterval(this.timer);
  }

  setAggregateViewData(data: any) {
    this.combinedThresholds = this.wallboardService.activeSiteConfigLife['CombinedPane'].Thresholds;
    this.combinedMetrics.title = this.wallboardService.activeSiteConfigLife['CombinedPane'].Title;
    this.mainTitle = this.wallboardService.activeSiteConfigLife['View'];
    this.combinedMetrics.metrics = data[0].metricsLife;
  }

  updateActiveSite(site: string) {
    this.wallboardService.setActiveSiteLife(site).then((data: any) => {
      this.secondEnabled = data.AggregateView;
      if (data.AggregateView) {
        this.setAggregateViewData(data);
      }
      this.wallboardService.setActiveQueueLife(this.wallboardService.queueListLife[0], site);
      this.siteMetrics = data;
      this.showWallboard = true;
      if (this.wallboardService.announcementsLife.length) {
        this.activeAnnouncement = this.wallboardService.announcementsLife[0]
      }
      if (!this.wbInterval) {
        this.startWallboardInterval();
      }
      if (this.route.snapshot.params.site !== encodeURIComponent(site)) {
        this.location.replaceState(`${this.configService.activeLOBLife}/wallboard-life/${encodeURIComponent(site)}`);
      }
    })
  }

  startWallboardInterval() {
    clearInterval(this.wbInterval);
    let intervalValue = this.wallboardService.activeSiteConfigLife.RotationDelay
    if (!this.wallboardService.activeSiteConfigLife.RotationDelay) {
      intervalValue = this.wallboardService.activeSiteConfigLife.RefreshInterval;
    }
    let frequency = Math.max(parseInt(intervalValue), 5)
    console.log("starting wallboard interval. update every " + String(frequency) + " seconds.")
    this.wbInterval = setInterval(async () => {
      if ((this.queueDisplayIteration + 1) < this.wallboardService.siteMetricsLife.length) {
        this.queueDisplayIteration++;
        this.wallboardService.setActiveQueueLife(this.wallboardService.queueListLife[this.queueDisplayIteration], this.wallboardService.activeSiteNameLife)
      } else {
        await this.wallboardService.getConfigDataLife(this.configService.activeLOBLife);
        await this.configService.getQueueList();
        this.updateActiveSite(this.wallboardService.activeSiteNameLife);
        this.wallboardService.getSiteMetricsLife(this.wallboardService.activeSiteNameLife).then((data: any[]) => {
          this.siteMetrics = data;
          this.queueDisplayIteration = 0;
          if (this.wallboardService.activeSiteConfigLife['AggregateView']) {
            this.setAggregateViewData(data);
          }
          this.wallboardService.setActiveQueueLife(this.wallboardService.queueListLife[0], this.wallboardService.activeSiteNameLife);
        })
      }

      if ((this.announcementIteration + 1) < this.wallboardService.announcementsLife.length) {
        this.announcementIteration++
        this.activeAnnouncement = this.wallboardService.announcementsLife[this.announcementIteration];
      } else {
        this.announcementIteration = 0;
        this.activeAnnouncement = this.wallboardService.announcementsLife[this.announcementIteration];
      }
    }, frequency * 1000 )
    return this.queueDisplayIteration;
  }
}
